<template>
    <div class="app-container">
        <el-card class="tableInfo">
            <div slot="header" class="clearfix">
                <span style="font-size:20px">banner图配置</span>
            </div>
             <!-- <el-row class="rowItem"> -->
                <!-- <el-col class="lable" :span="2">banner缩略图：</el-col>
                <el-col :span="22">
                    <div class="imgList" v-for="(item, index) in this.tbBannerList" :key="index">
                        <img :src="'http://zlesp.zlydgy.cn:8091/images/'+item.url" alt="">
                    </div>
                </el-col>
            </el-row>
            <el-row style="margin-top:50px">
                <el-col :span="10" :offset="2">
                    <el-button
                        style="width:120px"
                        type="primary"
                        @click="edit(tbBannerList)">
                        编辑
                    </el-button>
                </el-col>
            </el-row> -->
            <el-form :model="formparams" ref="formparams" label-width="100px">
                <el-form-item ref="uploadElement">
                    <el-upload
                        action="aa"
                        ref="upload"
                        list-type="picture-card"
                        :auto-upload="false"
                        :http-request="uploadFile"
                        :file-list="fileList"
                        multiple
                        :on-remove="handleRemove"
                        accept="image/png,image/gif,image/jpg,image/jpeg"
                        >
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    *提示*：为了更好的用户体验，图片请提供670*340像素，文件大小不超过500kb。
                </el-form-item>
            </el-form>
            <span class="dialog-footer">
                <!-- <el-button @click="resetForm()">取 消</el-button> -->
                <el-button style="width:120px;margin:20px 0 0 100px;" type="primary" @click="submitForm()">确 定</el-button>
            </span>
        </el-card>
        <!-- <el-dialog title="设置" :visible.sync="dialogVisible" width="1000px"> -->
            
        <!-- </el-dialog> -->
    </div>
</template>

<script>
import { VueCropper }  from 'vue-cropper' 
import mainHead from "../../components/mainHead/mainHead";
import { construct, destruct } from '@aximario/json-tree';
import { getConfigInfo, getBanner, saveConfigInfo, getNoConfigClubDataSource } from '../../api/configApi.js'
export default {
    props: {

    },
    data() {
        return {
            nodata: true,
            dialogVisible:false,
            loading: false,
            dialogImageUrl: '',
            dialogVisible2: false,
            disabled: false,
            list:[],
            uploadParams:'',
            getConfigList:[],
            fileList:[],//图片列表
            trueList:[],
            treeListData:[],
            espJson:[],
            showSlect:false,
            tbBannerList:[],
            options: [],
            formparams:{
                // clubMemberCode:'',
                uploadFile:[],
                type:'banner',
                configInfo:[],
                imageId:[]
            },
            props: {
                children: 'tbLimits',
                label: 'limitname'
            },
            defaultProps:{
                children: 'tbLimitConfigList',
                label: 'limitname'
            },
            option: {
                img: '',                         //裁剪图片的地址
                info: true,                      //裁剪框的大小信息
                outputSize: 1,                   // 裁剪生成图片的质量
                outputType: 'jpeg || png || webp',              //裁剪生成图片的格式
                canScale: false,                 // 图片是否允许滚轮缩放
                autoCrop: true,                  // 是否默认生成截图框
                autoCropWidth:680,              // 默认生成截图框宽度
                autoCropHeight:340,             // 默认生成截图框高度
                fixed: true,                    //是否开启截图框宽高固定比例
                fixedNumber: [2, 1]              //截图框的宽高比例
            },
            isShowCropper: false,            //是否显示截图框
            fileUpload: null,
            fileinfo: {},
            form: {},
            formData: {}
        };
    },
    computed: {
    },
    created() {
    },
    mounted() {
        this.getBanner()
    },
    watch: {

    },
    methods: {
        getNoConfigClubDataSource(){
            getNoConfigClubDataSource({typestatus:0}).then((res)=>{
                this.options = res.data
            })
        },
        getBanner(){
            getBanner({typestatus:1}).then((res)=>{
                if(res.msg == 'success'){
                    this.tbBannerList = res.data
                    this.fileList=[]
                    for(var i=0; i<res.data.length; i++){  
                        this.fileList.push({url:'http://zlesp.zlydgy.cn:8091/images/'+res.data[i].url, id:res.data[i].id})
                    }
                }else{
                    this.$message.error(res.message)
                }
            })
        },
        showDialog() {
            this.dialogVisible = true
            this.showSlect= true
            this.fileList = []
            this.formparams.imageId =[]
            this.getNoConfigClubDataSource()
            this.getConfigInfo()
        },  
        handleRemove(file) {
            this.formparams.imageId.push(file.id)
            console.log(this.formparams.imageId);
        },
        handlePictureCardPreview(file) {
            this.fileUpload = file;
        //上传成功后将图片地址赋值给裁剪框显示图片
            this.$nextTick(() => {
                this.option.img = file.url;
                this.isShowCropper = false
            })
        },
        getConfigInfo(){
             getConfigInfo().then((res)=>{
                if(res.msg == 'success'){
                    this.getConfigList = res.data.tbLimits
                    this.espJson = []
                    this.espJson.push({id:res.data.id,limit:res.data.limit,limitname:res.data.limitname,pid:res.data.pid})
                }else{
                    this.$message.error(res.message)
                }
            })
        },
        //编辑添加权限管理
        edit(row){
            this.fileList=[]
            for(var i=0; i<row.length; i++){  
                this.fileList.push({url:'http://zlesp.zlydgy.cn:8091/images/'+row[i].url, id:row[i].id})
            }
            this.dialogVisible = true
        },
        uploadFile(file){
            this.formData.append('uploadFile', file.file);
        },
        resetForm(){
            this.dialogVisible = false
        },
        async submitForm(){
            this.formData = new FormData()
            this.$refs.upload.submit();
            if(this.$refs.upload.uploadFiles.length==0){
                this.$message.error('上传轮播图不能为空');
                return
                } else {
                    for (let i = 0; i < this.$refs.upload.uploadFiles.length; i++) {
                        // const element = this.$refs.upload.uploadFiles[i].name;
                        if(this.$refs.upload.uploadFiles[i].size/1024>500){
                            this.$message.error('上传图片大小不能超过500kb');
                            this.fileList= []
                            return
                        }
                        if(this.$refs.upload.uploadFiles[i].name){
                            let nameARR = this.$refs.upload.uploadFiles[i].name.split('.')
                            var re;
                            re =  /^[A-Za-z0-9]+$/g;
                            if (!re.test(nameARR[0])) {
                                this.$message.error('上传图片名称只能是数字字母组合');
                                return
                            }
                        }
                        
                    }
            }
            this.formData.append('type', "banner");
            if(this.formparams.imageId.length!=0&&this.showSlect==false){
                this.formData.append('imageId', '['+this.formparams.imageId+']');
            }
            let config = {
                headers: {
                    'Content-Type':'multipart/form-data',
                    'token':sessionStorage.getItem('token')
                }
            }
           const {data: res} = await this.$http.post('configFunction/saveBanner', this.formData, config)
           if(res.msg == 'success'){
               this.$message({
                   type:'success',
                   message:'修改成功'
               })
               this.dialogVisible = false
               this.getBanner()
               this.fileList=[]
               this.formparams.imageId= []
           }
        },
        removeList(){
            this.$router.push({path:'/demo'})
        }

    },
    components: {
        mainHead,
        VueCropper
    },
};
</script>

<style scoped lang="scss">
.app-container {
  position: relative;
  height: auto;
  .tableInfo {
    height: 85vh;
    overflow-y: auto;
    .clearfix{
        font-size: 20px;
       font-weight: bolder;
    }
    .rowItem{
        padding: 20px;
        border-bottom: 1px solid #f2f2f2; 
        .lable{
            font-size: 16px;
            font-weight:bolder; 
        }
    }
    .imgList{
        width: 200px;
        height: 100px;
        margin-bottom: 10px;
        margin-left: 10px;
        border-radius: 10px;
        overflow: hidden;
        background: #f2f2f2;
        float: left;
        img{
            width: 100%;
            height: 100%;
        }
    }
  }
  .pageination {
    position: absolute;
    top: 82vh;
    left: 0;
    right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// configurable.vue?bc56582a